import { DateFormatType } from './date-format-key'

export const DATE_FORMAT_OPTIONS = [
  { value: DateFormatType.DdMm, label: 'DD/MM/YYYY' },
  { value: DateFormatType.MmDd, label: 'MM/DD/YYYY' },
]
